import React, { useEffect, useState } from "react";
import api from "../../../services/api";
import MultiSelect from "../../../components/MultiSelect";
import Loader from "../../../components/loader";

export default ({ values = [], onChange }) => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await api.post("/project/search", {
        status: "active",
      });

      let projectsData = res.data.projects.sort((a, b) => a.name?.toLowerCase().localeCompare(b.name?.toLowerCase())).map((j) => ({ value: j._id, label: j.name }));

      projectsData.push({ value: "", label: "" });
      setProjects(projectsData);
    })();
  }, []);

  if (!projects?.length) return <Loader size="small" />;

  return <MultiSelect id="select-projects" options={projects} values={values} onSelectedChange={onChange} placeholder="Select a project" />;
};
